import React, { useEffect } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, makeStyles, Typography } from '@material-ui/core';
import clsx from 'clsx';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import GeneralInformation from '../generalInformation';
import CrcLabelE from './crcLabelE';
import CrcLabelD from './crcLabelD';
import CrcLabelC from './crcLabelC';
import CrcLabelB from './crcLabelB';
import CrcLabelA from './crcLabelA';
import './styles.css';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    heading1: {
        fontSize: '18px',
        fontWeight: 700,
        color: '#000',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightMedium,
        color: '#4c4c4d',
        fontFamily: 'Rubik',
    },
    cardContent: {
        boxShadow: '0 0 10px grey',
        marginTop: theme.spacing(2),
    },
    accordContentSummary: {
        background: '#f9f9f9',
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 10px 0px 0px',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
}));

function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}
const CrcTotalIncome = (props, yesorNoType) => {
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState('');
    const [labelResponse, setLabelResponse] = React.useState('');
    const [updateValuesfromChild, setUpdateValuesfromChild] = React.useState('');

    const responseValueapiResponse = labelResponse && labelResponse.apiResponse[7];
    const responseValueSubquestion = responseValueapiResponse && responseValueapiResponse.subQuestion[5];
    const totalincomeradio = responseValueSubquestion && responseValueSubquestion.fields[0].response;
    //console.log('yesorNoType', props.yesorNoType);

    const statusIDResult = props.serviceIdValue;

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    const handleChangeParent = (prop) => {
        //console.log("prop inside TotalIncome",prop);
        setUpdateValuesfromChild({ prop });
        props.onChange(prop);
    };

    // const directorType = checklist1que && checklist1que[5].fields[0].response;
    //console.log('directorType', directorType);

    useEffect(() => {
        setLabelResponse(props.apiResponse);
    }, [props]);

    return (
        <Grid container spacing={3} className="main-container w100i">
            <Grid item xs={12} sm={12}>
                {/* <FormControl component="fieldset" disabled>
                    <RadioGroup defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option">
                        <ul className="makeStyles-inlineDisplay-111">
                            <li>
                                <FormControlLabel name="directorType" value="Yes" control={<StyledRadio />} label="Yes" />
                            </li>
                            <li>
                                <FormControlLabel name="directorType" value="No" control={<StyledRadio />} label="No" />
                            </li>
                        </ul>
                    </RadioGroup>
                </FormControl> */}

                <FormControl component="fieldset" disabled>
                    <RadioGroup
                        disabled
                        defaultValue="Yes"
                        aria-label="yes-no"
                        name="totalincomeradio"
                        className="radio-option"
                        name="customized-radios"
                        id="totalincomeradio"
                        // onChange={formik.handleChange}
                        value={totalincomeradio}
                        // onChange={formik.handleChange}
                    >
                        <ul className={classes.inlineDisplay}>
                            <li>
                                <FormControlLabel name="totalincomeradio" value="Yes" control={<StyledRadio />} label="Yes" />
                            </li>
                            <li>
                                <FormControlLabel name="totalincomeradio" value="No" control={<StyledRadio />} label="No" />
                            </li>
                        </ul>
                    </RadioGroup>
                </FormControl>
            </Grid>
            {totalincomeradio === 'Yes' ? (
                <>
                    <Typography
                        variant="subtitle1"
                        gutterBottom
                        className="mb15 mt15"
                        style={{ fontWeight: '500', color: '#4c4c4d', fontSize: '15px' }}
                    >
                        Personal Assets
                    </Typography>
                    <Grid style={{ border: '1px solid #e6e5e5' }}>
                        <Accordion square expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel1a-header" className="padding10">
                                <Typography className={classes.heading}>A. Details of immovable asset</Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordContentSummary}>
                                <CrcLabelA
                                    rerenderApi={props.rerenderApi}
                                    rerender={props.rerender}
                                    labelResponse={labelResponse}
                                    yesorNoType={props.yesorNoType}
                                    addAdditionalQue={props.addAdditionalQue}
                                    onChange={handleChangeParent}
                                />
                            </AccordionDetails>
                        </Accordion>
                        <Accordion square expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel2a-header" className="padding10">
                                <Typography className={classes.heading}>B. Details of movable asset</Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordContentSummary}>
                                <CrcLabelB
                                    rerenderApi={props.rerenderApi}
                                    rerender={props.rerender}
                                    labelResponse={labelResponse}
                                    yesorNoType={props.yesorNoType}
                                    addAdditionalQue={props.addAdditionalQue}
                                    onChange={handleChangeParent}
                                />
                            </AccordionDetails>
                        </Accordion>
                        <Accordion square expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel3a-header" className="padding10">
                                <Typography className={classes.heading}>
                                    C. Whether you have held unlisted equity shares at any time during the previous year{' '}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordContentSummary}>
                                <CrcLabelC
                                    rerenderApi={props.rerenderApi}
                                    rerender={props.rerender}
                                    labelResponse={labelResponse}
                                    yesorNoType={props.yesorNoType}
                                    addAdditionalQue={props.addAdditionalQue}
                                    onChange={handleChangeParent}
                                />
                            </AccordionDetails>
                        </Accordion>
                        <Accordion square expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel4a-header" className="padding10">
                                <Typography className={classes.heading}>
                                    D. Interest held in the assets of a firm or association of persons (AOP) as a partner or member thereof
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordContentSummary}>
                                <CrcLabelD
                                    rerenderApi={props.rerenderApi}
                                    rerender={props.rerender}
                                    labelResponse={labelResponse}
                                    yesorNoType={props.yesorNoType}
                                    addAdditionalQue={props.addAdditionalQue}
                                    onChange={handleChangeParent}
                                />
                            </AccordionDetails>
                        </Accordion>
                        <Accordion square expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel5a-header" className="padding10">
                                <Typography className={classes.heading}>
                                    E. Liabilities (if any) relating to the above assets at A,B and C
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordContentSummary}>
                                <CrcLabelE
                                    rerenderApi={props.rerenderApi}
                                    rerender={props.rerender}
                                    labelResponse={labelResponse}
                                    yesorNoType={props.yesorNoType}
                                    addAdditionalQue={props.addAdditionalQue}
                                    statusIDResult={statusIDResult}
                                    onChange={handleChangeParent}
                                />
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                </>
            ) : (
                ''
            )}
        </Grid>
    );
};

export default CrcTotalIncome;
